import { render, staticRenderFns } from "./appPorcelain.vue?vue&type=template&id=1bcf5471&scoped=true&"
import script from "./appPorcelain.vue?vue&type=script&lang=js&"
export * from "./appPorcelain.vue?vue&type=script&lang=js&"
import style0 from "./appPorcelain.vue?vue&type=style&index=0&id=1bcf5471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf5471",
  null
  
)

export default component.exports